import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=50c5d04f&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5d04f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c5d04f')) {
      api.createRecord('50c5d04f', component.options)
    } else {
      api.reload('50c5d04f', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=50c5d04f&scoped=true&", function () {
      api.rerender('50c5d04f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h2bKtpKX6bcB/JS/comp/Voucher-Unit.vue"
export default component.exports